import Spinners from "components/Common/Spinner"
import React from "react"

import { Row, Col } from "reactstrap"

import { useUpdateResolveInvestorOnboardedStepMutation } from "store/api/wealthpartnerapi/onboardResolve.api"

const BlockedStepsForWp = ({ kycData, currentStep, querySteps = [] }) => {
  const [updateStep, { isLoading }] =
    useUpdateResolveInvestorOnboardedStepMutation()

  const goToStep = async () => {
    try {
      await updateStep({
        kyc_status: getNextKey(currentStep),
        id: kycData?.id,
      }).unwrap()
      window.location.reload()
    } catch (error) {}
  }

  const getNextKey = (currentStep) => {
    const currentIndex = querySteps.findIndex(
      (item) => item.key === currentStep
    )

    if (currentIndex === querySteps.length - 1) return "FINAL_STEP"
    const nextKey = querySteps[currentIndex + 1]?.key || null
    return nextKey
  }

  return (
    <>
      <Row className="mb-2">
        <Col sm={12}>
          <Row className="mt-4">
            <div
              className={
                "py-4 d-flex flex-column align-items-center justify-content-between"
              }
            >
              <div
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  maxWidth: "500px",
                  margin: "0 auto",
                }}
              >
                <ul>
                  <li>
                    <p>
                      You can not Resole this step , Only Investor can fill the
                      required data needed in this step
                    </p>
                  </li>
                  <li>
                    <p>
                      You can <strong>skip</strong> and ask investor to complete
                      this after you resolve other queries, if any.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <Col lg={"12"}>
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isLoading}
                onClick={() => goToStep("")}
              >
                {isLoading ? <Spinners /> : "Skip & Next"}
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default BlockedStepsForWp
